import ProgressLoader from '../plugins/progressLoader';

class Loader {

	constructor() {

		this.storageType = 'sessionStorage';
		this.$loader = $('.Loader');
		this.$progress = $('.Loader__Logo--dark');
		this.$images = $('[data-preload]');

		this.load();

	}

	load() {

		this.totalLoaded = 0;

		if (this.totalLoaded === 0) {
			this.updateUI();
		}

		this.$images.each((index, item) => {
			const src = item.src;

			const loader = new ProgressLoader(src, {
				onComplete: () => {
					this.totalLoaded++;
					this.updateUI();
				}
			});

		});

	}

	updateUI() {

		let perc;

		if (this.$images.length === 0) {
			perc = 1;
		} else {
			perc = this.totalLoaded/this.$images.length;
		}
		this.$progress.css('clip','rect(0px, ' + (perc * 150) + 'px, 50px, 0px)')
		if (perc === 1) {
			setTimeout(() => {
				this.$loader.fadeOut();
			}, 500);
		}

	}



}

export default new Loader();



// WEBPACK FOOTER //
// ./js/components/loader.js